export const members = [
  {
    id: '1',
    name: 'Bob'
  },
  {
    id: '2',
    name: 'John'
  },
  {
    id: '3',
    name: 'Sue'
  }
];
